(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const theme = window.TolunTheme || {};

  window.addEventListener('load', () => setTimeout(() => $('.loader')?.classList.add('hide'), 280));

  const header = $('#header');
  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    if (!header) return;
    const y = window.scrollY;
    header.classList.toggle('scrolled', y > 20);
    if (y > 260 && y > lastScroll + 7) header.style.transform = 'translateY(-100%)';
    if (y < lastScroll - 7 || y < 260) header.style.transform = 'translateY(0)';
    lastScroll = y;
  }, { passive: true });

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: .14 }) : null;
  const initReveal = () => $$('.reveal').forEach(el => revealObserver ? revealObserver.observe(el) : el.classList.add('visible'));
  initReveal();

  const heroVideo = $('.hero-video');
  if (heroVideo) {
    heroVideo.muted = true;
    const play = () => heroVideo.play?.().catch(() => {});
    play();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) play(); });
  }

  const cartDrawer = $('.cart-drawer');
  const backdrop = $('.cart-backdrop');
  const cartItems = $('[data-cart-items]');
  const cartTotal = $('[data-cart-total]');
  const cartCountEls = $$('[data-cart-count]');

  const formatMoney = cents => {
    try { return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 }).format(cents / 100); }
    catch (_) { return `${(cents / 100).toFixed(2)} TL`; }
  };

  function openCart() {
    cartDrawer?.classList.add('open'); backdrop?.classList.add('open');
    cartDrawer?.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer?.classList.remove('open'); backdrop?.classList.remove('open');
    cartDrawer?.setAttribute('aria-hidden', 'true'); document.body.style.overflow = '';
  }

  async function getCart() {
    if (!theme.cartUrl) return null;
    const res = await fetch(`${theme.cartUrl}.js`, { headers: { Accept: 'application/json' } });
    if (!res.ok) throw new Error('Sepet alınamadı');
    return res.json();
  }

  function renderCart(cart) {
    if (!cart) return;
    cartCountEls.forEach(el => el.textContent = cart.item_count);
    if (cartTotal) cartTotal.textContent = formatMoney(cart.total_price);
    if (!cartItems) return;
    if (!cart.items.length) { cartItems.innerHTML = '<p class="empty">Sepetiniz boş.</p>'; return; }
    cartItems.innerHTML = cart.items.map(item => `
      <div class="cart-row">
        <div><strong>${item.product_title}</strong><small>${item.quantity} × ${formatMoney(item.final_price)}</small></div>
        <button type="button" data-remove-key="${item.key}">Kaldır</button>
      </div>`).join('');
    $$('[data-remove-key]', cartItems).forEach(btn => btn.addEventListener('click', async () => {
      const body = JSON.stringify({ id: btn.dataset.removeKey, quantity: 0 });
      const res = await fetch(theme.cartChangeUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body });
      renderCart(await res.json());
    }));
  }

  $('.cart-open')?.addEventListener('click', async () => { try { renderCart(await getCart()); } catch (_) {} openCart(); });
  $('.cart-close')?.addEventListener('click', closeCart);
  backdrop?.addEventListener('click', closeCart);

  document.addEventListener('click', async e => {
    const btn = e.target.closest('.add-cart[data-variant-id]');
    if (!btn || btn.disabled) return;
    e.preventDefault(); btn.disabled = true;
    try {
      const res = await fetch(theme.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] }) });
      if (!res.ok) throw new Error('Ürün eklenemedi');
      renderCart(await getCart()); openCart();
    } finally { btn.disabled = false; }
  });

  const searchOverlay = $('.search-overlay');
  $('.search-open')?.addEventListener('click', () => { searchOverlay?.classList.add('open'); searchOverlay?.setAttribute('aria-hidden', 'false'); setTimeout(() => $('.search-field input')?.focus(), 250); });
  $('.search-close')?.addEventListener('click', () => { searchOverlay?.classList.remove('open'); searchOverlay?.setAttribute('aria-hidden', 'true'); });

  const mobilePanel = $('.mobile-nav-panel');
  const mobileButton = $('.mobile-menu');
  mobileButton?.addEventListener('click', () => {
    const open = !mobilePanel?.classList.contains('open');
    mobilePanel?.classList.toggle('open', open); mobilePanel?.setAttribute('aria-hidden', String(!open));
    mobileButton.setAttribute('aria-expanded', String(open)); document.body.style.overflow = open ? 'hidden' : '';
  });
  $$('.mobile-nav-panel a').forEach(link => link.addEventListener('click', () => { mobilePanel?.classList.remove('open'); document.body.style.overflow = ''; }));

  const floatingCta = $('.floating-customize');
  window.addEventListener('scroll', () => {
    if (!floatingCta) return;
    const show = window.scrollY > window.innerHeight * .8 && window.scrollY < document.documentElement.scrollHeight - window.innerHeight * 1.2;
    floatingCta.classList.toggle('show', show);
  }, { passive: true });

  const luxuryCursor = $('.luxury-cursor');
  if (luxuryCursor && matchMedia('(pointer:fine)').matches) {
    window.addEventListener('mousemove', e => { luxuryCursor.style.left = `${e.clientX}px`; luxuryCursor.style.top = `${e.clientY}px`; luxuryCursor.style.opacity = '1'; });
    const bindCursor = () => {
      $$('a,button,input,.product-card,.editorial-card').forEach(el => {
        if (el.dataset.cursorBound) return; el.dataset.cursorBound = '1';
        el.addEventListener('mouseenter', () => luxuryCursor.classList.add('hover'));
        el.addEventListener('mouseleave', () => luxuryCursor.classList.remove('hover'));
      });
    };
    bindCursor();
    $$('.hero,.editorial-card,.manifesto').forEach(el => {
      el.addEventListener('mouseenter', () => luxuryCursor.classList.add('on-dark'));
      el.addEventListener('mouseleave', () => luxuryCursor.classList.remove('on-dark'));
    });
  }

  if (matchMedia('(pointer:fine) and (prefers-reduced-motion: no-preference)').matches) {
    const parallaxMedia = $$('.vision-media img,.precision-media img');
    window.addEventListener('scroll', () => parallaxMedia.forEach(img => {
      const r = img.parentElement.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) {
        const center = r.top + r.height / 2 - innerHeight / 2;
        img.style.transform = `translate3d(0,${center * -0.018}px,0) scale(1.035)`;
      }
    }), { passive: true });
  }

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeCart(); searchOverlay?.classList.remove('open'); mobilePanel?.classList.remove('open'); document.body.style.overflow = '';
  });

  document.addEventListener('shopify:section:load', () => initReveal());
})();
